export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7124.3e996c3e.jpg";